/**
 * @preserve
 * jQuery Make Sticky - v1.0.0
 * Copyright (c) 2014 Karsten Müller
 */

/**
 * jQuery Plugin to make element sticky when scrolling down.
 *
 * Requires _jquery.scroll-toggle.js
 *
 * The point where the kontext get sticky can set by using data-sticky-offset="[number]";
 *   [number] in pixels, default is 0 (top of the viewport);
 */

(function ( $ ){

	var defaults = {
		offset: 0
	};

	$.fn.makeSticky = function(options){

		var options = options || {};

		if (typeof $.fn.scrollToggle !== "undefined"){

			var z_index = 100;

			return this.each(function(){

				var kontext = $(this);

				var settings = {
					z_index: z_index++
				}

					/* Einstellungen über Data-Attribute */

				var data = {
					offset: kontext.data("sticky-offset")
				}

					/* Einstellungen vereinen */

				settings = $.extend(settings, defaults, options, data);


				new StickyElement(kontext, settings);

			});

		} else {

			return this;

		}

	};

	var StickyElement = function(kontext, settings){

		var self = this;

		this.kontext = kontext;
		this.settings = settings;


			// Kontext stylen

		this.kontext.removeClass("set-sticky").addClass("sticky").css("position", "absolute").css("z-index", this.settings.z_index);


			// Platzhalter für Element (wegen position: absolute)

		$('<div/>').insertAfter(this.kontext).height(this.kontext.outerHeight(true));


			// scrollToggle

		this.kontext.scrollToggle({
			callbackIn: function(){
				self.stick(true)
			},
			callbackOut: function(){
				self.stick(false)
			}
		});

	}

	StickyElement.prototype.stick = function(stick){

		if (stick){
			this.kontext.addClass("stuck").css({
				position: "fixed",
				top: this.settings.offset
			});
		} else {
			this.kontext.removeClass("stuck").css({
				position: "absolute",
				top: "inherit"
			});
		}

	}

}( jQuery ));
